import React from "react"

export const Hidden = (props) => {
    const { condition, children } = props

    return condition ? children : null
}
